import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { AppBarConfiguration } from "scmp-app/components/app-bar/types";
import { StyledMenuBar, StyledMenuItem } from "scmp-app/components/entity-oneline-menu-lite/styles";
import type { subSectionPostMagazineProfileQuery$key } from "scmp-app/queries/__generated__/subSectionPostMagazineProfileQuery.graphql";

import { Container, Description, Explore, Name, StyledTopicLink, Tags } from "./styles";

export type Props = {
  appBarConfiguration?: AppBarConfiguration;
  className?: string;
  reference: subSectionPostMagazineProfileQuery$key;
};

export const SubSectionPostMagazineProfile: FunctionComponent<Props> = ({
  className,
  reference: reference_,
}) => {
  const { section, topicQueue } = useFragment(
    graphql`
      fragment subSectionPostMagazineProfileQuery on Query
      @argumentDefinitions(
        entityId: { type: "String!" }
        postMagazineSubSectionTopicQueueName: { type: "String!" }
      ) {
        section(filter: { entityId: $entityId }) {
          name
          description {
            text
          }
        }
        topicQueue: queue(filter: { name: $postMagazineSubSectionTopicQueueName }) {
          items(first: 5) {
            edges {
              node {
                ... on Topic {
                  entityId
                  ...topicLinkTopic
                }
              }
            }
          }
        }
      }
    `,
    reference_,
  );

  return (
    <Container className={className}>
      <Name>{section.name}</Name>
      <Description>{section.description?.text}</Description>
      <Explore>explore {section.name}</Explore>
      <Tags>
        <StyledMenuBar>
          {topicQueue?.items?.edges?.map(({ node }) => (
            <StyledMenuItem key={node?.entityId}>
              <StyledTopicLink reference={node} />
            </StyledMenuItem>
          ))}
        </StyledMenuBar>
      </Tags>
    </Container>
  );
};

SubSectionPostMagazineProfile.displayName = "SubSectionPostMagazineProfile";
